import React, { useReducer, useState } from 'react';
import { Form, ProgressCircle, TextArea, TextField, } from '@adobe/react-spectrum';
import { Button, ToggleButton } from '@react-spectrum/button';
import { Flex } from '@react-spectrum/layout';
import { View } from '@react-spectrum/view';
import { call } from 'app/utils/function';
import { ContactLinks } from './Links';
const Emojis = [
    {
        code: '1f929',
        url: '/assets/icons/1f929.svg',
        value: 0,
    },
    {
        code: '1f600',
        url: '/assets/icons/1f600.svg',
        value: 25,
    },
    {
        code: '1f615',
        url: '/assets/icons/1f615.svg',
        value: 75,
    },
    {
        code: '1f62d',
        url: '/assets/icons/1f62d.svg',
        value: 100,
    },
];
const validateText = (text) => String(text !== null && text !== void 0 ? text : '').trim().length > 3;
const Rating = (props) => {
    const { value, onChange } = props;
    return (React.createElement(Flex, { gap: "size-50" }, Emojis.map(emoji => {
        const emojiValue = Math.floor((emoji.value / 100) * Emojis.length) + 1;
        const isSelected = value === emojiValue;
        return (React.createElement(ToggleButton, { key: emoji.code, isSelected: isSelected, UNSAFE_style: {
                borderColor: isSelected
                    ? 'var(--spectrum-global-color-static-blue-300)'
                    : undefined,
            }, onPress: !isSelected
                ? () => call(onChange, emojiValue)
                : null },
            React.createElement(Flex, { width: "size-250", alignItems: "center", justifyContent: "center" },
                React.createElement("img", { src: emoji.url, alt: `Rate ${emojiValue}` }))));
    })));
};
const initialState = {
    text: '',
    email: '',
    rating: -1,
    ready: false,
    invalid: false,
};
const FeedbackForm = (props) => {
    const { endpoint, isVertical = false } = props;
    const [busy, setBusy] = useState(false);
    const [state, dispatch] = useReducer((pState, pAction) => {
        let newState;
        switch (pAction.type) {
            case 'CLEAR':
                return Object.assign({}, initialState);
            case 'SET_INVALID':
                return Object.assign(Object.assign({}, newState), { invalid: true });
            case 'SET_EMAIL':
                newState = Object.assign(Object.assign({}, pState), { email: pAction.value, invalid: false });
                break;
            case 'SET_TEXT':
                newState = Object.assign(Object.assign({}, pState), { text: pAction.value, invalid: false });
                break;
            case 'SET_RATING':
                newState = Object.assign(Object.assign({}, pState), { rating: pAction.value, invalid: false });
                break;
            default:
                return pState;
        }
        newState.ready =
            validateText(newState.text) && newState.rating >= 0;
        return newState;
    }, initialState);
    const onSend = () => {
        if (busy) {
            return;
        }
        const { text, email, rating } = state;
        const isValid = validateText(text) && rating >= 0;
        if (!isValid) {
            dispatch({ type: 'SET_INVALID' });
            return;
        }
        const bodyData = {
            subject: 'Editor feedback',
            message: `${text}
            ---
            rating: ${rating}
            ---
            version: ${Env.config.RELEASE.version},
            date: ${Env.config.RELEASE.date},
            branch: ${Env.config.RELEASE.branch},
            commit: ${Env.config.RELEASE.commit},
            `,
            name: '',
            email,
            feedback: {
                text,
                email,
                rating,
            },
            editor: {
                version: Env.config.RELEASE.version,
                date: Env.config.RELEASE.date,
                branch: Env.config.RELEASE.branch,
                commit: Env.config.RELEASE.commit,
            },
        };
        Promise.any([
            new Promise(resolve => {
                setTimeout(resolve, 1000);
            }),
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    Referer: 'szoter.com',
                    Authorization: 'Bearer xXx',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyData),
            })
                .then(() => {
                dispatch({ type: 'CLEAR' });
            })
                .catch(error => {
                getLogger('Feedback', 'error')(error);
                return false;
            }),
        ]).then(() => {
            setBusy(false);
        });
        setBusy(true);
    };
    return (React.createElement(View, { padding: "size-200" },
        React.createElement(Form, { validationState: state.invalid ? 'invalid' : undefined },
            React.createElement(TextArea, { label: "All the nice words", isRequired: true, value: state.text, onChange: value => dispatch({ type: 'SET_TEXT', value }) }),
            React.createElement(TextField, { label: "Email", isRequired: false, value: state.email, onChange: value => dispatch({ type: 'SET_EMAIL', value }) }),
            React.createElement(Flex, { gap: isVertical ? 'size-200' : 'size-50', marginTop: "size-200", direction: isVertical ? 'column' : 'row', alignItems: isVertical ? 'center' : 'start' },
                React.createElement(Rating, { value: state.rating, onChange: value => dispatch({ type: 'SET_RATING', value }) }),
                React.createElement(Button, { variant: "primary", marginStart: isVertical ? '0px' : 'size-400', isDisabled: !state.ready, onPress: onSend }, "Send"))),
        busy && (React.createElement(View, { position: "absolute", backgroundColor: "gray-50", top: "0px", left: "0px", right: "0px", bottom: "0px" },
            React.createElement(Flex, { alignItems: "center", justifyContent: "center", height: "100%" },
                React.createElement(ProgressCircle, { size: "M", isIndeterminate: true }))))));
};
export const FeedbackView = (props) => (React.createElement(Flex, { direction: "column", gap: "size-100" },
    React.createElement(FeedbackForm, Object.assign({}, props)),
    React.createElement(ContactLinks, null)));
